var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchConversesionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.166,
    height: 17.167,
    viewBox: "0 0 17.166 17.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_125",
    "data-name": "Union 125",
    d: "M15.82,16.936l-2.393-2.392a8.217,8.217,0,1,1,1.116-1.115l2.391,2.392a.788.788,0,0,1-1.114,1.116ZM1.577,8.209a6.63,6.63,0,0,0,11.257,4.752.75.75,0,0,1,.06-.067.728.728,0,0,1,.067-.06A6.632,6.632,0,1,0,1.577,8.209Z",
    transform: "translate(0)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchConversesionIcon);
export default __webpack_public_path__ + "static/media/SearchConversesionIcon.ee92c6f2c1b27510dfb3e5be14fa5825.svg";
export { ForwardRef as ReactComponent };